webpackJsonp([5],{

/***/ 74:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//

exports.default = function () {
  return _react2.default.createElement(
    "div",
    null,
    _react2.default.createElement(
      "div",
      { className: "datenschutzerklaerung" },
      _react2.default.createElement(
        "h1",
        null,
        "Datenschutzerkl\xE4rung"
      ),
      _react2.default.createElement(
        "h2",
        null,
        "Allgemeines"
      ),
      _react2.default.createElement(
        "p",
        null,
        "Der sorgf\xE4ltige Umgang mit ihren personenbezogenen Daten hat h\xF6chste Priorit\xE4t. Wir halten uns bei deren Erhebung, Verarbeitung und Nutzung streng an die datenschutzrechtlichen Bestimmungen des Datenschutzgesetzes (DSG) und der Datenschutzgrundverordnung (EU-DSGVO). Nachfolgend erfahren sie mehr \xFCber den Umgang mit ihren personenbezogenen Daten."
      ),
      _react2.default.createElement(
        "h2",
        null,
        "Was sind personenbezogene Daten?"
      ),
      _react2.default.createElement(
        "p",
        null,
        "Personenbezogene Daten sind alle Angaben \xFCber Betroffene, durch die die Identit\xE4t des Betroffenen bestimmt oder bestimmbar ist. Angaben k\xF6nnen s\xE4mtliche Informationen sein, die mit einer Person in Verbindung stehen oder gebracht werden k\xF6nnen, wie z.B. ihr Name, ihre Adresse, ihre E-Mail-Adresse, ihr Geburtsdatum. Wir ersuchen ausschlie\xDFlich um Bekanntgabe jener pers\xF6nlichen Informationen, welche wir zur Auftragserf\xFCllung unbedingt ben\xF6tigen. Die zur Verf\xFCgung gestellten Daten werden ausschlie\xDFlich zur Auftragserf\xFCllung herangezogen. Es erfolgt im \xDCbrigen keine \xDCbermittlung der Daten an Dritte, soweit diese nicht zur Durchf\xFChrung einer Anfrage oder Dienstleistung erforderlich ist."
      ),
      _react2.default.createElement(
        "h2",
        null,
        "Datensicherheit"
      ),
      _react2.default.createElement(
        "p",
        null,
        "Wir sichern unsere Webseite und die sonstigen Systeme durch technische und organisatorische Ma\xDFnahmen gegen Verlust, Zerst\xF6rung, Zugriff, Ver\xE4nderung oder Verbreitung ihrer Daten und treffen umfangreiche Sicherheitsma\xDFnahmen, um ihre Daten vor unerw\xFCnschten Zugriffen zu sch\xFCtzen."
      ),
      _react2.default.createElement(
        "h2",
        null,
        "Server-Logfiles"
      ),
      _react2.default.createElement(
        "p",
        null,
        "Wenn sie unsere Webseite besuchen, speichern wir zum Zweck der System- und Datensicherheit u.a. folgende Daten (sogenannte Serverlogfiles), die ihr Internet-Browser an uns bzw. an unseren Webspace-Provider \xFCbermittelt, ab:"
      ),
      _react2.default.createElement(
        "ul",
        null,
        _react2.default.createElement(
          "li",
          null,
          "Browsertyp und -version"
        ),
        _react2.default.createElement(
          "li",
          null,
          "verwendetes Betriebssystem"
        ),
        _react2.default.createElement(
          "li",
          null,
          "Webseite, von der aus sie uns besuchen \"Referrer URL\""
        ),
        _react2.default.createElement(
          "li",
          null,
          "Webseite, die sie besuchen"
        ),
        _react2.default.createElement(
          "li",
          null,
          "Datum und Uhrzeit ihres Zugriffs"
        ),
        _react2.default.createElement(
          "li",
          null,
          "Ihre Internet Protokoll (IP)-Adresse"
        )
      ),
      _react2.default.createElement(
        "p",
        null,
        "Diese anonymen Daten werden getrennt von ihren eventuell angegebenen personenbezogenen Daten gespeichert und lassen so keine R\xFCckschl\xFCsse auf eine bestimmte Person zu. Sie werden zu statistischen Zwecken ausgewertet, um unseren Internetauftritt und unsere Angebote optimieren zu k\xF6nnen."
      )
    )
  );
};

/***/ })

});


// WEBPACK FOOTER //
// templates/src/containers/Datenschutzerklaerung.00a16e2f.js